import Swiper, {Navigation, Pagination} from 'swiper';

export default function swiper() {

    new Swiper('.b-10 .swiper', {
        autoplay: {
            delay: 5000,
        },
        spaceBetween: 0,
        slidesPerView: 1,
        loop: false,
        pagination: {
            el: '.b-10 .swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.b-10 .swiper-button-next',
            prevEl: '.b-10 .swiper-button-prev',
            clickable: true
        },
        breakpoints: {
            1140: {
                slidesPerView: 3,
            },
        },
        modules: [Navigation, Pagination]
    })

    new Swiper('.b-12 .swiper', {
        autoplay: {
            delay: 5000,
        },
        spaceBetween: 0,
        slidesPerView: 1,
        loop: false,
        pagination: {
            el: '.b-12 .swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.b-12 .swiper-button-next',
            prevEl: '.b-12 .swiper-button-prev',
            clickable: true
        },
        breakpoints: {
            1160: {
                slidesPerView: 3,
            },
        },
        modules: [Navigation, Pagination]
    })
}
